import { useRouteError, Link } from 'react-router-dom';
import '../css/pageerror.css';

function ErrorPage() {
  const error = useRouteError();

  let title = 'An error occurred!';
  let message = 'Something went wrong!';

  if (error.status === 500) {
    message = error.data.message;
  }

  if (error.status === 404) {
    title = 'Page Not found!';
    message = "The page you're looking for doesn't exist or has been moved.";
  }

  return (
    <>
      <div className="page-error custom-bg text-dark">
          <div className="page-error-center d-flex align-items-center justify-content-center min-vh-100 px-2">
              <div className="text-center">                   
                  <div className="page-error-404">
                      <h1>{error.status}</h1>
                  </div>
                  <p className="fs-3 fw-bold">PAGE NOT FOUND</p>
                  <p className="message">The page you are looking for doesn't exist or has been moved..</p>                  
                  <Link to="/">Go To Homepage</Link>
              </div>
          </div>
      </div>
    </>
  );
}

export default ErrorPage;
